import { useModal } from '@billy/design-system'
import { useCallback, useState } from 'react'

import { useUpdateVatExemptionMention } from '@features/invoicingSettings/hooks/useUpdateVatExemptionMention'

import { ModalId } from '../../../../../../../enums/modalId'

export interface UseInvoiceSettingsModalsVatExemptionMentionResult {
  defaultValue: string
  isSubmitting: boolean
  onSubmit: (value: string) => void
  openModal: (defaultValue: string) => void
  shouldUpdateForm: boolean
  vatExemptionMentionScheme: string
}

export const useInvoiceSettingsModalsVatExemptionMention = (): UseInvoiceSettingsModalsVatExemptionMentionResult => {
  const [shouldUpdateForm, setShouldUpdateForm] = useState(false)
  const [vatExemptionMentionScheme, setVatExemptionMentionScheme] = useState('')
  const { update: updateVatExemptionMention, isProcessing, isLoading } = useUpdateVatExemptionMention()

  const { open: openVatExemptionMentionModal, close: closeVatExemptionMentionModal } = useModal(
    ModalId.VatExemptionMentionModal,
  )

  const handleSubmit = useCallback(
    (value: string) => {
      updateVatExemptionMention(value, () => {
        setVatExemptionMentionScheme(value)
        setShouldUpdateForm(true)
        closeVatExemptionMentionModal()
      })
    },
    [closeVatExemptionMentionModal, updateVatExemptionMention],
  )

  const handleOpen = useCallback(
    (defaultValue: string) => {
      setVatExemptionMentionScheme(defaultValue)
      setShouldUpdateForm(false)
      openVatExemptionMentionModal()
    },
    [openVatExemptionMentionModal],
  )

  return {
    defaultValue: vatExemptionMentionScheme,
    isSubmitting: isProcessing || isLoading,
    onSubmit: handleSubmit,
    openModal: handleOpen,
    shouldUpdateForm,
    vatExemptionMentionScheme,
  }
}
